import { useApolloClient } from "@apollo/client";
import Graph_QL, { GqlHook_Returns } from "..";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { AnimalEvent } from "../AnimalDataCalls/GQLCalls/getAnimalCall";
import { BasicQueryInfoInput } from "../FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { useCallback, useState } from "react";
import { ANIMAL_EVENT, AnimalEventResponse, CREATE_ANIMAL_EVENT, CreateAnimalEventResponse } from "./GQLCalls/getEvents";
import { AnimalEventInfo, selectAllEvents, selectEventById, upsertEvents } from "./eventsSlice";

interface EventHelperFunctions {
  // maintainEventEntries: (domain: string, animalid: number, eventdefinitionid: number, timestamp: number, note: string) => Promise<boolean>;
}

export const useEvent = (domain: string) => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [, setCursorId] = useState(-1);

  const getEventInfo = useCallback(async (input: BasicQueryInfoInput, idIdentifier?: string): Promise<AnimalEventInfo[]> => {
    try {
      const response = await client.query<AnimalEventResponse>({ query: ANIMAL_EVENT, variables: { domain, input, idIdentifier } })
      const data = response.data.animal.info.flatMap((animal) => (animal.event.map((e) => ({ ...e, animal_id: animal.animal_id }))))
      dispatch(upsertEvents(data))
      return data
    } catch (error) {
      console.log("gok", error)
    }
    return []
  }, [client, dispatch, domain])

  const createEvent = useCallback(async (animalid: number, eventdefinitionid: number, timestamp: number, note: string): Promise<boolean> => {
    try {
      const response = await client.mutate<CreateAnimalEventResponse>({ mutation: CREATE_ANIMAL_EVENT, variables: { domain, animalid, eventdefinitionid, timestamp, note } })
      const success = response.data?.animal.createEvent.success ?? false;
      if (success) getEventInfo({ ids: [animalid] });
      return success;
    } catch (error) {
      console.log("gok", error)
    }
    return false;
  }, [client, domain, getEventInfo])

  return {getEventInfo, createEvent}
}

export const ANIMAL_EVENT_NOTE_ID = 1 as const;